module.exports = __webpack_public_path__ + "static/media/xp-banner2.0ffcb381.jpg";